
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/lib/toast"

interface ProfileUpdateData {
  name?: string;
  telefone?: string;
  foto_perfil_url?: string | null;
}

export const useProfileMutations = () => {
  const [isUpdating, setIsUpdating] = useState(false);

  const updateProfile = async (userId: string, updates: ProfileUpdateData) => {
    if (!userId) return false;

    setIsUpdating(true);
    try {
      const { error } = await supabase
        .from('users')
        .update(updates)
        .eq('id', userId);

      if (error) {
        console.error("Erro ao atualizar perfil:", error);
        toast.error("Erro ao atualizar perfil");
        return false;
      }

      toast.success("Perfil atualizado com sucesso!");
      return true;
    } catch (error) {
      console.error("Erro ao atualizar perfil:", error);
      toast.error("Erro ao atualizar perfil");
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    isUpdating,
    updateProfile
  };
};
